export default [
  {
    id: '1',
    title: 'Jaką wodę wybierasz?',
    answers: [
      {
        text: 'Kranówkę z wielorazowego bidonu',
        isCorrect: true,
        hint:
          'Brawo! Picie wody z kranu jest dobre dla środowiska (nie powstaje zbędny plastik) i dla Twojej kieszeni. Ogromna większość wodociągów w Polsce zapewnia wodę o jakości lepszej niż przeciętna woda z butelki. Najlepiej wlewać ją kilka sekund po odkręceniu kranu do metalowego lub szklanego bidonu.',
      },
      {
        text: 'Ze sklepu w jednorazowej butelce',
        isCorrect: false,
        hint:
          'Spróbuj przekonać się do kranówki! Picie wody z kranu jest dobre dla środowiska (nie powstaje zbędny plastik) i dla Twojej kieszeni. Ogromna większość wodociągów w Polsce zapewnia wodę o jakości lepszej niż przeciętna woda z butelki. Najlepiej wlewać ją kilka sekund po odkręceniu kranu do metalowego lub szklanego bidonu.',
      },
    ],
    image: 'images/1.png',
  },
  {
    id: '2',
    title: 'W Twojej ulubionej bluzie zepsuł się zamek. Co robisz?',
    answers: [
      {
        text: 'Zanosisz do naprawy do krawca',
        isCorrect: true,
        hint:
          'Znakomicie! Naprawianie zepsutych rzeczy to jedna z głównych zasad ekologicznego stylu życia. Lepiej naprawić niż wyrzucać. To oszczędność zasobów ziemi, które się kończą (uprawy roślin dla przemysłu modowego pochłaniają ogromne ilości wody) oraz pieniędzy. To także stawianie oporu przemysłowi reklamowemu, który wciąż namawia nas do kupowania.',
      },
      {
        text: 'Kupujesz nową, starą wyrzucasz',
        isCorrect: false,
        hint:
          'Może przekonasz się do naprawiania? Naprawianie zepsutych rzeczy to jedna z głównych zasad ekologicznego stylu życia. Lepiej naprawić niż wyrzucać. To oszczędność zasobów ziemi, które się kończą (uprawy roślin dla przemysłu modowego pochłaniają ogromne ilości wody) oraz pieniędzy. To także stawianie oporu przemysłowi reklamowemu, który wciąż namawia nas do kupowania.',
      },
    ],
    image: 'images/2.png',
  },
  {
    id: '3',
    title: 'Planujesz wakacje…',
    answers: [
      {
        text: 'Pociąg i rower, w przyrodzie',
        isCorrect: true,
        hint:
          'Świetnie! Wakacje spędzone lokalnie, na które jedziemy pociągiem lub samochodem w kilka osób, a potem korzystamy z rowerów nie przyczyniają się do emisji dwutlenku węgla, tak jak przelot na dalekie plaże. A przecież mogą być równie ciekawe! ',
      },
      {
        text: 'Byle jak najdalej, samolotem…',
        isCorrect: false,
        hint:
          'Może następnym razem spróbujesz zrezygnować z dalekich podróży samolotem? Wakacje spędzone lokalnie, na które jedziemy pociągiem lub samochodem w kilka osób, a potem korzystamy z rowerów nie przyczyniają się do emisji dwutlenku węgla, tak jak przelot na dalekie plaże. A przecież mogą być równie ciekawe! ',
      },
    ],
    image: 'images/3.png',
  },
  {
    id: '4',
    title: 'Idąc na zakupy:',
    answers: [
      {
        text: 'Zabierasz z domu własną torbę',
        isCorrect: true,
        hint:
          'Gratulacje! Chodzenie na zakupy z własną wielorazową torbą to jeden z najprostszych nawyków ekologicznych. Po co nam dziesiątki plastikowych reklamówek, które rozkładają się setki lat?',
      },
      {
        text: 'Korzystasz z płatnych reklamówek',
        isCorrect: false,
        hint:
          'Spróbuj to zmienić. Chodzenie na zakupy z własną wielorazową torbą to jeden z najprostszych nawyków ekologicznych. Po co nam dziesiątki plastikowych reklamówek, które rozkładają się setki lat?',
      },
    ],
    image: 'images/4.png',
  },
  {
    id: '5',
    title: 'Śniadanie do szkoły:',
    answers: [
      {
        text: 'Przynosisz z domu w wielorazowym pudełku',
        isCorrect: true,
        hint:
          'Tylko tak dalej! Domowe jedzenie jest tańsze i zazwyczaj zdrowsze niż produkty kupione w sklepiku. W dodatku nie powstają odpady, bo brudny pojemnik możesz zapakować i umyć w domu. ',
      },
      {
        text: 'Kupujesz w sklepiku, a opakowania wyrzucasz',
        isCorrect: false,
        hint:
          'A może pomyślisz nad innym rozwiązaniem?  Domowe jedzenie jest tańsze i zazwyczaj zdrowsze niż produkty kupione w sklepiku. W dodatku nie powstają odpady, bo brudny pojemnik możesz zapakować i umyć w domu.',
      },
    ],
    image: 'images/5.png',
  },
  {
    id: '6',
    title: 'Zepsuły ci się słuchawki',
    answers: [
      {
        text: 'Szukasz serwisu, w którym możesz je naprawić',
        isCorrect: true,
        hint:
          'Brawo! Naprawianie zepsutych rzeczy to jedna z głównych zasad ekologicznego stylu życia. Lepiej naprawić niż wyrzucać. To oszczędność zasobów ziemi, które się kończą oraz pieniędzy. To także stawianie oporu przemysłowi reklamowemu, który namawia nas do kupowania co sezon nowej rzeczy, a przecież w ten sposób rośnie góra odpadów!',
      },
      {
        text: 'Kupujesz nowe (w promocji)',
        isCorrect: false,
        hint:
          'Może przekonasz się do naprawiania? Naprawianie zepsutych rzeczy to jedna z głównych zasad ekologicznego stylu życia. Lepiej naprawić niż wyrzucać. To oszczędność zasobów ziemi, które się kończą oraz pieniędzy. To także stawianie oporu przemysłowi reklamowemu, który wciąż namawia nas do kupowania co sezon nowej rzeczy, a przecież w ten sposób rośnie góra odpadów!',
      },
    ],
    image: 'images/6.png',
  },
  {
    id: '7',
    title: 'Mydło pod prysznic, szampon i inne kosmetyki z łazienki:',
    answers: [
      {
        text:
          'Ograniczasz ich ilość, zwracasz uwagę na opakowanie (szkło lub forma kostki)',
        isCorrect: true,
        hint:
          'Brawo! W naszych łazienkach powstaje bardzo dużo odpadów. Warto wrócić do zwyczajów sprzed lat i nie kupować dziesiątek różnych kosmetyków. Jeśli coś potrzeba, wybierz szampon lub mydło w kostce albo szklanym opakowaniu. ',
      },
      {
        text: 'Kupujesz w plastikowych opakowaniach',
        isCorrect: false,
        hint:
          'Zastanów się nad zmianą nawyków. W naszych łazienkach powstaje bardzo dużo odpadów. Warto wrócić do zwyczajów sprzed lat i nie kupować dziesiątek różnych kosmetyków. Jeśli coś potrzeba, wybierz szampon lub mydło w kostce albo szklanym opakowaniu. ',
      },
    ],
    image: 'images/7.png',
  },
  {
    id: '8',
    title: 'Lubisz mieć czyste uszy:',
    answers: [
      {
        text:
          'Wybierasz patyczki papierowe, bambusowe lub myjesz uszy wodą z mydłem i wycierasz rogiem ręcznika',
        isCorrect: true,
        hint:
          'Znakomicie! Plastikowe patyczki do uszu są jednym z symboli niepotrzebnych przedmiotów, do których przyzwyczailiśmy się. Lata temu w ogóle ich nie stosowano, a dziś stanowią sporą część zanieczyszczeń wyławianych z wód. Na szczęście nie są nam niezbędne!',
      },
      {
        text: 'Używasz plastikowych patyczków do ich czyszczenia',
        isCorrect: false,
        hint:
          'Hmmm... spróbuj zrezygnować z ich używania.  Plastikowe patyczki do uszu są jednym z symboli niepotrzebnych przedmiotów, do których stosowania przyzwyczailiśmy się. Lata temu w ogóle ich nie stosowano, a dziś stanowią spora część zanieczyszczeń wyławianych z wód. Na szczęście nie są nam niezbędne!',
      },
    ],
    image: 'images/8.png',
  },
  {
    id: '9',
    title: 'Jest gorąco i masz ochotę na lody:',
    answers: [
      {
        text: 'Wybierasz takie w wafelku',
        isCorrect: true,
        hint:
          'Świetnie! Aby zjeść smacznego loda, nie trzeba produkować odpadów. Podobnie sprawa się ma nawet z frytkami zamawianymi w wafelku czy jedzeniem podanym na jadalnych talerzach z otrębów. ',
      },
      {
        text: 'Zabierasz do plastikowego kubeczka i jesz jednorazową łyżeczką',
        isCorrect: false,
        hint:
          'A może spróbujesz inaczej? Aby zjeść smacznego loda, nie trzeba produkować odpadów. Podobnie sprawa ma się nawet z frytkami zamawianymi w wafelku czy jedzeniem podanym na jadalnych talerzach z otrębów. ',
      },
    ],
    image: 'images/9.png',
  },
  {
    id: '10',
    title: 'Masz ochotę na kawę w popularnej sieci:',
    answers: [
      {
        text:
          'Zamawiasz ją na miejscu i wypijasz w filiżance lub zabierasz do własnego kubka',
        isCorrect: true,
        hint:
          'To nam się podoba! Moda na jednorazowe kubki, z którymi chodzi się po ulicy przyszła do nas niedawno. A przecież kawę można wypić na miejscu lub w ostateczności zabrać ją do własnego wielorazowego kubka.',
      },
      {
        text: 'Pędzisz dalej z kubkiem jednorazowym w ręku',
        isCorrect: false,
        hint:
          'Czy to konieczne? Moda na jednorazowe kubki, z którymi chodzi się po ulicy przyszła do nas niedawno. A przecież kawę można wypić na miejscu lub w ostateczności zabrać ją do własnego wielorazowego kubka.',
      },
    ],
    image: 'images/10.png',
  },
  {
    id: '11',
    title: 'Zamawiasz sok w restauracji. Kelner podaje do niego słomkę:',
    answers: [
      {
        text: 'Odmawiasz, bo nie jest ci potrzebna',
        isCorrect: true,
        hint:
          'Znakomicie! Plastikowe słomki są jednym z symboli niepotrzebnych przedmiotów, do których przyzwyczailiśmy się. Dziś stanowią sporą część zanieczyszczeń wyławianych z wód, a przecież poza rzadkimi przypadkami wcale nie są nam niezbędne! ',
      },
      {
        text: 'Bierzesz, bo tak się wygodnie pije',
        isCorrect: false,
        hint:
          'Spróbuj odmówić następnym razem. Plastikowe słomki są jednym z niepotrzebnych przedmiotów, do których przyzwyczailiśmy się. Dziś stanowią sporą część zanieczyszczeń wyławianych z wód, a przecież poza rzadkimi przypadkami wcale nie są nam niezbędne! ',
      },
    ],
    image: 'images/11.png',
  },
  {
    id: '12',
    title: 'Musisz dojechać do szkoły na 8 rano:',
    answers: [
      {
        text: 'Jedziesz rowerem lub komunikacją miejską',
        isCorrect: true,
        hint:
          'Gratulacje! Dzięki Twojej samodzielności mniej spalin trafi do atmosfery. Podwożenie dzieci do szkoły to zwyczaj ostatnich lat. ',
      },
      {
        text: 'Prosisz rodziców, by cię podwieźli',
        isCorrect: false,
        hint:
          'Może pomyślisz nad zmianą nawyków? Dzięki Twojej samodzielności mniej spalin trafi do atmosfery. Podwożenie dzieci do szkoły to zwyczaj ostatnich lat. ',
      },
    ],
    image: 'images/12.png',
  },
  {
    id: '13',
    title: 'Zepsute sprzęty AGD, których nie da się już naprawić:',
    answers: [
      {
        text: 'Oddajesz w punkcie zbiórki elektroodpadów',
        isCorrect: true,
        hint:
          'Bardzo dobrze! W punkcie zbiórki elektroodpadów stare radio lub telefon trafi w dobre ręce. Specjaliści odzyskają z niego to, co cenne, a reszta trafi w bezpieczny sposób do przetworzenia. ',
      },
      {
        text: 'Wyrzucasz do kosza',
        isCorrect: false,
        hint:
          'Ojej, lepiej tego nie rób, nie wiadomo jaki wpływ na środowisko będzie miał niewłaściwie składowany sprzęt.  W punkcie zbiórki elektroodpadów stare radio lub telefon trafi w dobre ręce. Specjaliści odzyskają z niego to, co cenne, a reszta trafi w bezpieczny sposób do przetworzenia.',
      },
    ],
    image: 'images/13.png',
  },
  {
    id: '14',
    title: 'Chcesz kupić kg bananów:',
    answers: [
      {
        text: 'Bierzesz kilka samotnych bananów bez opakowania',
        isCorrect: true,
        hint:
          'Dobra decyzja! Samotne (pojedyncze) banany zazwyczaj trafiają w sklepie do śmietnika. Kupując je zapobiegasz marnowaniu żywności. A przy tym są smaczne i nie powodujesz powstawania kolejnych śmieci. ',
      },
      {
        text:
          'Odrywasz banana od nienaruszonej kiści lub bierzesz kiść w folii',
        isCorrect: false,
        hint:
          'A może sięgnij po owoce bez opakowania?  Samotne (pojedyncze) banany zazwyczaj trafiają w sklepie do śmietnika. Kupując je zapobiegasz marnowaniu żywności. A przy tym są smaczne i nie powodujesz powstawania kolejnych śmieci. ',
      },
    ],
    image: 'images/14.png',
  },
  {
    id: '15',
    title: 'Masz kota i kupujesz dla niego karmę w puszce. Gdy jest pusta:',
    answers: [
      {
        text:
          'Sadzisz w niej roślinę lub wrzucasz do pojemnika na tworzywa sztuczne',
        isCorrect: true,
        hint:
          'Dobry pomysł! Upcykling albo recykling to rozwiązania godne polecenia. Po co marnować surowce, z których została wykonana puszka?',
      },
      {
        text: 'Wyrzucasz do śmietnika na odpady zmieszane',
        isCorrect: false,
        hint:
          'Następnym razem zastanów się, czy tak zrobić. Upcykling albo recykling to rozwiązania godne polecenia. Po co marnować surowce, z których została wykonana puszka?',
      },
    ],
    image: 'images/15.png',
  },
  {
    id: '16',
    title: 'Wybierasz napój na piknik:',
    answers: [
      {
        text: 'W szklanej butelce',
        isCorrect: true,
        hint:
          'Super! Szkło jest surowcem, którego w przeciwieństwie do większości plastiku mozna używac wielokrotnie. Poza tym nawet,  gdy się stłucze, jego drobinki stanowią szybko biodegradowalny element natury, w przeciwienstwie do plastiku.  ',
      },
      {
        text: 'W plastikowym pojemniku',
        isCorrect: false,
        hint:
          'Czy ten plastik jest konieczny? Szkło jest surowcem, którego w przeciwieństwie do większości plastiku można używać wielokrotnie. Poza tym nawet,  gdy się stłucze, jego drobinki stanowią szybko biodegradowalny element natury, w przeciwieństwie do plastiku.  ',
      },
    ],
    image: 'images/16.png',
  },
  {
    id: '17',
    title: 'Lubisz czytać książki, więc:',
    answers: [
      {
        text: 'Korzystasz z bibliotek',
        isCorrect: true,
        hint:
          'Świetnie! Biblioteki to centra kultury lokalnej! Większość książek czytamy jeden raz, dlatego warto wypożyczać.',
      },
      {
        text: 'Zawsze kupujesz',
        isCorrect: false,
        hint:
          'Zastanów się, czy musisz mieć nowe książki. Większość z nich czytamy jeden raz, dlatego warto je wypożyczać w bibliotekach. To co, zapiszesz się jeszcze dziś?',
      },
    ],
    image: 'images/17.png',
  },
  {
    id: '18',
    title: 'Ogryzki od jabłek, obierki kuchenne, resztki niezjedzonej sałatki:',
    answers: [
      {
        text:
          'Przerabiasz we własnym lub społecznym kompostowniku albo wrzucasz do pojemnika na odpady bio',
        isCorrect: true,
        hint:
          'Super! Resztki organiczne to cenny surowiec do wytworzenia kompostu, czyli wartościowej dla roślin ziemi pełnej minerałów. To, czego nie zjemy, może się jeszcze im przydać! Kompostowaniem może zająć się każdy, nawet mieszkając w bloku. Brawo!',
      },
      {
        text: 'Wrzucasz do wc',
        isCorrect: false,
        hint:
          'Niestety, do toalety nie powinny trafiać odpadki z naszych koszów! Resztki organiczne to cenny surowiec do wytworzenia kompostu, czyli wartościowej dla roślin ziemi pełnej minerałów. To, czego nie zjemy, może się jeszcze im przydać! Kompostowaniem może zająć się każdy, nawet mieszkając w bloku. Może zgłębisz temat i spróbujesz?',
      },
    ],
    image: 'images/18.png',
  },
  {
    id: '19',
    title: 'Jeśli bułka jest wczorajsza..',
    answers: [
      {
        text: 'Podgrzewasz w opiekaczu i zjadasz',
        isCorrect: true,
        hint:
          'Brawo! Czerstwe pieczywo można kreatywnie wykorzystać w kuchni. Często bardzo proste sposoby pozwalają nam na niemarnowanie jedzenia. A pieczywa, jako Polacy, marnujemy najwięcej. ',
      },
      {
        text: 'Wyrzucasz ją do śmieci',
        isCorrect: false,
        hint:
          'Czerstwe pieczywo można kreatywnie wykorzystać w kuchni. Często bardzo proste sposoby pozwalają nam na niemarnowanie jedzenia. A pieczywa, jako Polacy, marnujemy najwięcej. Może następnym razem zrobisz grzanki lub wykorzystasz jako bułkę tartą?',
      },
    ],
    image: 'images/19.png',
  },
  {
    id: '20',
    title: 'Jesteś na wycieczce i widzisz śmieci w lesie...',
    answers: [
      {
        text: 'Starasz się je pozbierać',
        isCorrect: true,
        hint:
          'Każdy może być lokalnym bohaterem, Ty właśnie takim jesteś. Nawet małe sprzątanie lasu sprawia, że żyjemy w czystszym i piękniejszym miejscu, a rozkładający się plastik nie będzie zatruwał powietrza mikrocząsteczkami. Może inni wezmą z Ciebie przykład!',
      },
      {
        text: 'Przechodzisz obok ',
        isCorrect: false,
        hint:
          'Nie ma co się oglądać na innych, żeby posprzątali. Każdy może być lokalnym bohaterem, również Ty. Nawet małe sprzątanie lasu sprawia, że żyjemy w czystszym i piękniejszym miejscu, a rozkładający się plastik nie będzie zatruwał powietrza mikrocząsteczkami. Może się ośmielisz, a kolejnym razem inni wezmą z Ciebie przykład!',
      },
    ],
    image: 'images/20.png',
  },
  {
    id: '21',
    title: 'Na Dzień Matki/ Ojca lub pod choinkę:',
    answers: [
      {
        text: 'Wykonujesz prezenty własnoręcznie',
        isCorrect: true,
        hint:
          'Wspaniale! Prezenty są formą wyrażenia uczuć, ale nie zawsze muszą być kupione. Własnoręcznie zrobiony ładny praktyczny przedmiot na pewno ucieszy Twoich bliskich, bo docenią Twoje zaangażowanie. ',
      },
      {
        text: 'Prosisz rodziców o pieniądze, by kupić im prezenty',
        isCorrect: false,
        hint:
          'Zastanów się nad zmianą tego przyzwyczajenia.  Prezenty są formą wyrażenia uczuć, ale nie zawsze muszą być kupione. Własnoręcznie zrobiony ładny praktyczny przedmiot na pewno ucieszy Twoich bliskich, bo docenią Twoje zaangażowanie. ',
      },
    ],
    image: 'images/21.png',
  },
  {
    id: '22',
    title: 'Na swoje urodziny...',
    answers: [
      {
        text: 'Prosisz o wpłaty na organizację ochrony przyrody lub zwierząt',
        isCorrect: true,
        hint:
          'Wspaniale! Prezenty są formą wyrażenia uczuć, ale nie zawsze muszą być materialne. Po co Ci kolejny przedmiot, jeśli te same pieniądze Twoi bliscy mogą przeznaczyć na ważny dla Ciebie cel...',
      },
      {
        text: 'Prosisz o najnowszą zabawkę lub grę',
        isCorrect: false,
        hint:
          'Czy na pewno warto? Prezenty są formą wyrażenia uczuć, ale nie zawsze muszą być materialne. Po co Ci kolejny przedmiot, jeśli te same pieniądze Twoi bliscy mogą przeznaczyć na ważny dla Ciebie cel?',
      },
    ],
    image: 'images/22.png',
  },
  {
    id: '23',
    title: 'Jesteś chory i masz katar:',
    answers: [
      {
        text:
          'Używasz materiałowych chustek do nosa, które pierze się w pralce',
        isCorrect: true,
        hint:
          'Znakomicie. Chusteczki jednorazowe to jeden z tych przedmiotów, do jakich przywyczailiśmy się. Tymczasem mozna je zastąpić zwykłymi materiałowymi, jakich używali Wasi rodzice. Nawet przy porządnym katarze!',
      },
      {
        text: 'Otaczają cię chustki jednorazowe',
        isCorrect: false,
        hint:
          'Przemyśl, czy to konieczne. Chusteczki jednorazowe to jeden z tych przedmiotów, do jakich przyzwyczailiśmy się. Tymczasem mozna je zastąpić zwykłymi materiałowymi, jakich używali Wasi rodzice. Nawet przy porządnym katarze!',
      },
    ],
    image: 'images/23.png',
  },
  {
    id: '24',
    title: 'W szkole:',
    answers: [
      {
        text: 'Piszesz napełnianym piórem lub zmieniasz wkłady do długopisów',
        isCorrect: true,
        hint:
          'Twoja decyzja nam się podoba. Jednorazowe długopisy to chyba najczęściej trafiająca do śmietników element piórnika. A przecież są inne rozwiązania. ',
      },
      {
        text: 'Używasz długopisów i cienkopisów, które po wypisaniu wyrzucasz',
        isCorrect: false,
        hint:
          'A moze zaopatrzysz się w pióro na naboje lub wymienisz wkłady w długopisie? Jednorazowe długopisy to chyba najczęściej trafiająca do śmietników element piórnika. A przecież są inne rozwiązania. ',
      },
    ],
    image: 'images/24.png',
  },
  {
    id: '25',
    title: 'Telefon to dziś podstawa, a zatem:',
    answers: [
      {
        text:
          'Naprawiasz telefon, jeśli się zepsuje lub inwestujesz w model, który posłuży ci wiele lat',
        isCorrect: true,
        hint:
          'Słusznie, bez telefonu trudno dziś żyć, ale czy trzeba zmieniać go tak często, jak chcieliby tego producenci? Produkcja każdego aparatu wiąże się z wydobyciem cennych pierwiastków, a używane telefony często trafiają do śmieci. Dobrze więc robisz naprawiając telefony lub inwestując w model, który posłuży ci wiele lat. ',
      },
      {
        text: 'Zmieniasz aparat co dwa lata',
        isCorrect: false,
        hint:
          'Hmmm, bez telefonu trudno dziś żyć, ale czy trzeba zmieniać go tak często, jak chcieliby tego producenci? Produkcja każdego aparatu wiąże się z wydobyciem cennych pierwiastków, a używane telefony często trafiają do śmieci. Dobrze naprawiać telefony lub zainwestować w model, który posłuży ci wiele lat. ',
      },
    ],
    image: 'images/25.png',
  },
  {
    id: '26',
    title: 'Zero waste to:',
    answers: [
      {
        text:
          'Idea, która zmienia świadomość ludzi i promuje lepsze dla środowiska rozwiązania',
        isCorrect: true,
        hint:
          'Cieszymy się, że tak uważasz. To ważne także dla nas. Małe zmiany jakich dokonujemy w Po-Dzielni namawiając ludzi do ograniczenia kupowania cieszą nas każdego dnia. ',
      },
      {
        text: 'Kolejna moda',
        isCorrect: false,
        hint:
          'Przyjdź do Po-Dzielni i weź coś zamiast kupować. Wprowadź inne zmiany w swoim życiu. Może poczujesz, że to coś więcej niż modny trend.  To ważne także dla nas. Małe zmiany jakich dokonujemy w Po-Dzielni namawiając ludzi do ograniczenia kupowania cieszą nas każdego dnia. ',
      },
    ],
    image: 'images/26.png',
  },
  {
    id: '27',
    title:
      'Potrzebujesz statywu do aparatu, by zrobić zdjęcia dobrej jakości na imprezie;',
    answers: [
      {
        text: 'Wypożyczasz od znajomego',
        isCorrect: true,
        hint:
          'Bardzo dobrze! Nie wszystko trzeba mieć, by z tego korzystać. Polecamy wypożyczalnie!',
      },
      {
        text: 'Kupujesz go ',
        isCorrect: false,
        hint:
          'Czy faktycznie jest Ci aż tak potrzebny? Nie wszystko trzeba mieć, by z tego korzystać. Polecamy wypożyczalnie!',
      },
    ],
    image: 'images/27.png',
  },
  {
    id: '28',
    title: 'Robisz imprezę urodzinową:',
    answers: [
      {
        text: 'Przygotowujesz wielorazowe naczynia',
        isCorrect: true,
        hint:
          'Sto lat! i gratulacje! Jednorazówki są może wygodniejsze, ale ich zużycie na pewno nie służy środowisku. Korzystanie z naczyń wielorazowych to lepsze dla przyrody rozwiązanie. ',
      },
      {
        text: 'Kupujesz jednorazowe kubki, talerze i sztućce',
        isCorrect: false,
        hint:
          'Sto lat! Ale może następnym razem zrezygnujesz z jednorazówek?  Jednorazówki są może wygodniejsze, ale ich zużycie na pewno nie służy środowisku. Korzystanie z naczyń wielorazowych to lepsze dla przyrody rozwiązanie. ',
      },
    ],
    image: 'images/28.png',
  },
  {
    id: '29',
    title: 'Gdy panuje susza:',
    answers: [
      {
        text: 'Starasz się zadbać o rośliny w twojej okolicy, np. podlewając je',
        isCorrect: true,
        hint:
          'To niezwykle miłe! Rośliny wokół nas produkują dla nas tlen, dają cień i oczyszczają powietrze. Jak tylko możemy, pomagajmy im przetrwać!',
      },
      {
        text: 'Czekasz, aż spadnie deszcz',
        isCorrect: false,
        hint:
          'Zieleń jest potrzebna szczególnie w miastach. Rośliny wokół nas produkują dla nas tlen, dają cień i oczyszczają powietrze. Jak tylko możemy, pomagajmy im przetrwać!',
      },
    ],
    image: 'images/29.png',
  },
  {
    id: '30',
    title: 'Potrzebujesz krótkich spodni na wakacje:',
    answers: [
      {
        text:
          'Skracasz nienoszone długie spodnie, idziesz na zakupy do second handu albo bierzesz spodnie z Po-Dzielni',
        isCorrect: true,
        hint:
          'Bardzo lubimy Twój styl i sposób myślenia. Nawet jeśli moda jest ważna dla Ciebie, nie musi ona oznaczać ślepego podążania za trendami i wydawania pieniędzy. Na świecie jest już tyle ubrań, że nie trzeba by było ich produkować przez kilkadziesiąt lat!',
      },
      {
        text: 'Pędzisz do sklepu, gdzie zaczynają się wyprzedaże',
        isCorrect: false,
        hint:
          'A może jednak nie tędy droga? Nawet jeśli moda jest ważna dla Ciebie, nie musi ona oznaczać ślepego podążania za trendami i wydawania pieniędzy. Na świecie jest już tyle ubrań, że nie trzeba by było ich produkować przez kilkadziesiąt lat!',
      },
    ],
    image: 'images/30.png',
  },
];
